module.exports = __webpack_public_path__ + "img/refresh-2.3f0963c6.svg";